import React from 'react';
import ContentTitle from '../../../ContentTitle/ContentTitle.js';

const Content=(props)=>{
	let image_background=null,
		image_size=(props.feature===true?'':'resize=1&width=525');
		
	if(props.data.Metadata.header_banner)
		image_background=<img alt="" className={props.content_styles.feature} src={window.global.content_hub.ASSETS+'/images/'+props.data.Metadata.header_banner+'?'+image_size}/>;

	let styles={};
	Object.keys(props.content_styles || {}).forEach(k=>{
		styles[k]=(styles[k]===undefined?'':styles[k]+' ')+props.content_styles[k];
	});
	Object.keys(props.layout_styles || {}).forEach(k=>{
		styles[k]=(styles[k]===undefined?'':styles[k]+' ')+props.layout_styles[k];
	});

	return (
		<div className={styles.container} onClick={()=>window.open(props.data.URL,'_blank')}>
			<div className={styles.image_container}>
				{image_background}
			</div>
			<div className={styles.content_container}>
				<ContentTitle title={props.data.Title} styles={styles}/>
			</div>
		</div>
	);
}

export default Content;